Storage = require 'app/scripts/lib/storage'
LocalStorageModel = require 'app/scripts/view-models/internal/local-storage-model'

# We used to persist the Filter state in Local Storage manually, unscoped,
# If there's no existing state, use this one.
getOldValue = -> Storage.get 'visibilityFilter'
deleteOldValue = -> Storage.unset 'visibilityFilter'

module.exports = class NotificationFilterState extends LocalStorageModel
  VISIBILITY_ALL: 'VISIBILITY_ALL'
  VISIBILITY_UNREAD: 'VISIBILITY_UNREAD'

  constructor: (idMember) ->
    super
    @set({ id: "notificationFilterState-#{ idMember }" })
    @fetch()
    @enableTabSync()
    if @getVisibility() == null
      @setVisibility(getOldValue() || @VISIBILITY_UNREAD)
      deleteOldValue()

  default: ->
    visibilityFilter: null

  getVisibility: -> @get('visibilityFilter')

  setVisibility: (visibility) -> @update('visibilityFilter', visibility)

  toggleVisibility: ->
    currentVisibility = @getVisibility()
    newVisibility =
      if currentVisibility == @VISIBILITY_ALL
        @VISIBILITY_UNREAD
      else
        @VISIBILITY_ALL
    @setVisibility(newVisibility)
    return newVisibility

